import { render, staticRenderFns } from "./setsAndGroups.vue?vue&type=template&id=273654ab&scoped=true"
import script from "./setsAndGroups.vue?vue&type=script&lang=js"
export * from "./setsAndGroups.vue?vue&type=script&lang=js"
import style0 from "./setsAndGroups.vue?vue&type=style&index=0&id=273654ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273654ab",
  null
  
)

export default component.exports